module.exports = __webpack_public_path__ + "static/media/L (3).eaacc9a6.jpg";